// Edit-project modal — a thin wrapper around the shared ProjectForm (edit mode).
// Same body as the create modal; only the title and submit verb differ.

import type { Project } from "../../api/types";
import { ProjectForm } from "../ProjectForm";

interface Props {
  project: Project;
  onClose: () => void;
  onSaved: () => void;
}

export function EditProjectModal({ project, onClose, onSaved }: Props) {
  return <ProjectForm mode="edit" project={project} onClose={onClose} onDone={() => onSaved()} />;
}
